import React, { useState } from 'react';

function GuidedRemovalScreen({ addOns, selectedAddOns, onToggleAddOn, parentServiceId, serviceName, onSkip }) {
  const [needsRemoval, setNeedsRemoval] = useState(null);

  const formatPrice = (price) => price > 0 ? `+$${price}` : 'Free';

  // For single-select: deselect any currently selected removal, then select the new one
  function handleSelect(addOn) {
    // Deselect any other removal add-ons first
    const currentlySelected = addOns.filter(a =>
      selectedAddOns.some(s => s.id === a.id && s.parentServiceId === parentServiceId)
    );
    currentlySelected.forEach(a => {
      if (a.id !== addOn.id) onToggleAddOn(a, parentServiceId);
    });
    // Toggle this one
    const isSelected = selectedAddOns.some(s => s.id === addOn.id && s.parentServiceId === parentServiceId);
    if (!isSelected) onToggleAddOn(addOn, parentServiceId);
  }

  function handleNo() {
    // Deselect any previously selected removal add-ons
    const currentlySelected = addOns.filter(a =>
      selectedAddOns.some(s => s.id === a.id && s.parentServiceId === parentServiceId)
    );
    currentlySelected.forEach(a => onToggleAddOn(a, parentServiceId));
    // Skip straight to the next screen
    onSkip();
  }

  function handleYes() {
    setNeedsRemoval('yes');
  }

  function handleChange() {
    setNeedsRemoval(null);
  }

  return (
    <div className="guided-screen-content">
      <p className="guided-header-sub">This adds time to your appointment</p>

      <div className="guided-section">
        {/* Before selection: show big Yes/No buttons */}
        {needsRemoval === null && (
          <div className="guided-yesno-grid">
            <button className="guided-yesno-btn" onClick={handleYes}>
              <div className="guided-yesno-label">Yes</div>
              <div className="guided-yesno-sub">I need old product removed</div>
            </button>
            <button className="guided-yesno-btn" onClick={handleNo}>
              <div className="guided-yesno-label">No</div>
              <div className="guided-yesno-sub">My nails are bare</div>
            </button>
          </div>
        )}

        {/* After selection: collapsed pill */}
        {needsRemoval === 'yes' && (
          <div className="guided-yesno-collapsed selected-yes" onClick={handleChange}>
            <span className="guided-yesno-collapsed-check">✓</span>
            <span className="guided-yesno-collapsed-text">Yes — removal needed</span>
            <span className="guided-yesno-collapsed-change">Change</span>
          </div>
        )}

        {needsRemoval === 'yes' && (
          <div className="guided-removal-options">
            <div className="guided-section-title">Select Removal Type</div>
            <div className="guided-card-list">
              {addOns.map(addOn => {
                const isSelected = selectedAddOns.some(s => s.id === addOn.id && s.parentServiceId === parentServiceId);
                return (
                  <div
                    key={addOn.id}
                    className={`guided-card ${isSelected ? 'selected' : ''}`}
                    onClick={() => handleSelect(addOn)}
                  >
                    <div className="guided-card-left">
                      <div className="guided-card-name">{addOn.name}</div>
                      {addOn.description && <div className="guided-card-desc">{addOn.description}</div>}
                    </div>
                    <div className="guided-card-right">
                      <div className="guided-card-meta">
                        <div className="guided-card-price">{formatPrice(addOn.price)}</div>
                        {addOn.duration > 0 && <div className="guided-card-time">+{addOn.duration} min</div>}
                      </div>
                      <div className="guided-card-check">{isSelected ? '✓' : ''}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GuidedRemovalScreen;
